<template>
    <specialist-list
        :isActive="isActive"
        :type="'masters'"
    />
</template>

<script>
import specialistList from '@/components/lists/specialist/specialistList'

export default {
    name: 'mainView',
    props: {
        isActive: {
            required: true,
        },
    },
    components: {
        specialistList,
    },
}
</script>
